import { render } from "./ProductRequester.vue?vue&type=template&id=b6af8498"
import script from "./ProductRequester.vue?vue&type=script&lang=js"
export * from "./ProductRequester.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__